'use client'

import { useRouter, useSearchParams } from 'next/navigation'
import type { Category } from '@/lib/types'

interface CategoryFilterProps {
  categories: Category[]
}

export default function CategoryFilter({ categories }: CategoryFilterProps) {
  const router = useRouter()
  const searchParams = useSearchParams()
  const currentCategory = searchParams.get('category')

  const handleCategoryChange = (slug: string | null) => {
    if (slug) {
      router.push(`/shop?category=${slug}`)
    } else {
      router.push('/shop')
    }
  }

  return (
    <div className="mb-10">
      <div className="flex flex-wrap justify-center gap-3 mx-auto">
        <button
          onClick={() => handleCategoryChange(null)}
          className={`px-5 py-2 rounded-full text-sm font-semibold transition-all shadow-soft ${
            !currentCategory
              ? 'bg-primary text-white'
              : 'bg-white text-gray-700 hover:bg-cloud'
          }`}
        >
          All Products
        </button>
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => handleCategoryChange(category.slug)}
            className={`px-5 py-2 rounded-full text-sm font-semibold transition-all shadow-soft ${
              currentCategory === category.slug
                ? 'bg-secondary text-white'
                : 'bg-white text-gray-700 hover:bg-peach'
            }`}
          >
            {category.name}
          </button>
        ))}
      </div>
    </div>
  )
}
